export const initialState = {
    is_loading: true,
    sales_invoices: [],
    total_sales_invoices: 0,
    total_pages: 0,
    current_page: 1,
    search_value: ""
}